export default __webpack_public_path__ + "a3f06372a6a6f6c056cbc0f5b762cbf9.png";